import CookiesJS from 'js-cookie';
import { getSafeCookie } from './cookieHelper';

export const validateRoute = async() => {
    const pagesData = getSafeCookie('pages');
    if (!pagesData) {
        console.warn('⚠️ Cookie "pages" no encontrada, permitiendo acceso por defecto');
        return true; // Permitir acceso si no hay datos de páginas
    }
    const path = Array.isArray(pagesData) ? pagesData : [];
    const currentLocation = window.location.href.split('/').pop()
    let isValid = path.includes(currentLocation)
    // console.log(path)
    // console.log(currentLocation)
    // console.log(isValid)
    if (path.some(palabra => window.location.href.includes(palabra))) {
        // console.log("Se encontró una palabra clave en el texto.");
        isValid=true
      } else {
        // console.log("No se encontró ninguna palabra clave en el texto.");
        isValid = false
    }
    return isValid;
}

